var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 764.8 225.7",
    style: {
      enableBackground: "new 0 0 764.8 225.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#A6A6A6;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000106835702690508171420000017934702414345794986_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000063631977831664213400000009919177280232251307_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000129909892409232445330000003237195903628223156_);}\n\t.st8{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st9{opacity:0.12;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st10{opacity:0.25;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M736.5,225.7H28.3C12.7,225.7,0,213,0,197.5V28.2C0,12.7,12.7,0,28.3,0h708.1c15.6,0,28.3,12.7,28.3,28.2v169.3 C764.8,213,752.1,225.7,736.5,225.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M736.5,4.5c13.1,0,23.8,10.7,23.8,23.7v169.3c0,13-10.7,23.7-23.8,23.7H28.3c-13.1,0-23.8-10.7-23.8-23.7V28.2 c0-13,10.7-23.7,23.8-23.7C28.3,4.5,736.5,4.5,736.5,4.5z M736.5,0H28.3C12.7,0,0,12.7,0,28.2v169.3c0,15.5,12.7,28.2,28.3,28.2 h708.1c15.6,0,28.3-12.7,28.3-28.2V28.2C764.8,12.7,752.1,0,736.5,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M402.9,74.7c-5.1,0-9.4-1.8-12.8-5.3c-3.4-3.4-5.3-8.1-5.2-12.9c0-5.1,1.7-9.5,5.2-12.9 c3.4-3.5,7.7-5.3,12.8-5.3c5.1,0,9.4,1.8,12.8,5.3c3.4,3.6,5.2,7.9,5.2,12.9c-0.1,5.1-1.8,9.5-5.2,12.9 C412.3,72.9,408,74.7,402.9,74.7z M250.9,74.7c-5,0-9.3-1.8-12.9-5.2c-3.5-3.5-5.3-7.8-5.3-13s1.8-9.5,5.3-13 c3.5-3.5,7.8-5.2,12.9-5.2c2.5,0,4.9,0.5,7.2,1.5c2.3,1,4.1,2.3,5.5,3.9l0.3,0.4l-3.8,3.7l-0.4-0.5c-2.2-2.6-5-3.8-8.9-3.8 c-3.4,0-6.4,1.2-8.8,3.6c-2.5,2.4-3.7,5.6-3.7,9.4s1.3,7,3.7,9.4c2.4,2.4,5.4,3.6,8.8,3.6c3.6,0,6.7-1.2,9.1-3.6 c1.4-1.4,2.3-3.4,2.6-5.9h-12.2v-5.3h17.5l0.1,0.5c0.1,0.9,0.3,1.8,0.3,2.6c0,4.9-1.5,8.8-4.4,11.7 C260.5,72.9,256.1,74.7,250.9,74.7z M453,73.9h-5.4l-16.5-26.4l0.1,4.8v21.6h-5.4v-35h6.1l0.2,0.3l15.5,24.9l-0.1-4.7V38.9h5.4 L453,73.9L453,73.9z M362.4,73.9H357V44.2h-9.5v-5.3h24.4v5.3h-9.5L362.4,73.9L362.4,73.9z M343,73.9h-5.4v-35h5.4V73.9z  M312.4,73.9H307V44.2h-9.5v-5.3h24.4v5.3h-9.5V73.9z M294.1,73.9h-20.9V38.9h20.9v5.3h-15.4v9.6h13.9V59h-13.9v9.6h15.4V73.9z  M394.1,65.7c2.4,2.4,5.4,3.7,8.8,3.7c3.5,0,6.4-1.2,8.8-3.7c2.4-2.4,3.6-5.5,3.6-9.3s-1.2-6.9-3.6-9.3c-2.4-2.4-5.4-3.7-8.8-3.7 c-3.5,0-6.4,1.2-8.8,3.7c-2.4,2.4-3.6,5.5-3.6,9.3S391.7,63.4,394.1,65.7L394.1,65.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M384.4,122.7c-13.3,0-24.1,10.1-24.1,24c0,13.8,10.8,24,24.1,24c13.3,0,24.1-10.2,24.1-24 C408.5,132.8,397.7,122.7,384.4,122.7z M384.4,161.2c-7.3,0-13.5-6-13.5-14.5c0-8.7,6.3-14.5,13.5-14.5c7.3,0,13.5,5.9,13.5,14.5 C398,155.3,391.7,161.2,384.4,161.2z M331.9,122.7c-13.3,0-24.1,10.1-24.1,24c0,13.8,10.8,24,24.1,24c13.3,0,24.1-10.2,24.1-24 C356,132.8,345.2,122.7,331.9,122.7z M331.9,161.2c-7.3,0-13.5-6-13.5-14.5c0-8.7,6.3-14.5,13.5-14.5c7.3,0,13.5,5.9,13.5,14.5 C345.4,155.3,339.2,161.2,331.9,161.2z M269.4,130.1v10.2h24.4c-0.7,5.7-2.6,9.9-5.5,12.8c-3.6,3.6-9.1,7.5-18.8,7.5 c-15,0-26.7-12.1-26.7-27.1s11.7-27.1,26.7-27.1c8.1,0,14,3.2,18.4,7.3l7.2-7.2c-6.1-5.8-14.2-10.3-25.5-10.3 c-20.6,0-37.8,16.7-37.8,37.2c0,20.6,17.2,37.2,37.8,37.2c11.1,0,19.4-3.6,26-10.5c6.7-6.7,8.8-16.2,8.8-23.8c0-2.4-0.2-4.5-0.6-6.3 h-34.4C269.4,130,269.4,130.1,269.4,130.1z M525,138c-2-5.4-8.1-15.3-20.6-15.3c-12.4,0-22.6,9.7-22.6,24c0,13.5,10.2,24,23.8,24 c11,0,17.4-6.7,20-10.7l-8.1-5.5c-2.7,4-6.5,6.6-11.8,6.6c-5.4,0-9.2-2.4-11.7-7.3l32.1-13.3C526.2,140.7,525,138,525,138z  M492.3,146c-0.3-9.3,7.2-14,12.5-14c4.2,0,7.7,2.1,8.9,5.1L492.3,146z M466.2,169.3h10.5V98.7h-10.5V169.3z M448.9,128.1h-0.4 c-2.4-2.8-6.9-5.4-12.7-5.4c-12,0-23,10.5-23,24.1c0,13.5,11,23.9,23,23.9c5.7,0,10.3-2.6,12.7-5.5h0.4v3.4 c0,9.2-4.9,14.1-12.8,14.1c-6.5,0-10.5-4.6-12.1-8.5l-9.2,3.8c2.6,6.3,9.7,14.2,21.2,14.2c12.4,0,22.8-7.3,22.8-25v-43.1h-10 L448.9,128.1C449,128.1,448.9,128.1,448.9,128.1z M436.8,161.2c-7.3,0-13.4-6.1-13.4-14.5c0-8.5,6.1-14.6,13.4-14.6 c7.2,0,12.8,6.2,12.8,14.6C449.7,155.2,444,161.2,436.8,161.2z M574.4,98.7h-25.2v70.5h10.5v-26.7h14.7c11.7,0,23.1-8.5,23.1-21.9 S586.1,98.7,574.4,98.7z M574.7,132.7h-15v-24.2h15c7.9,0,12.4,6.5,12.4,12.1C587,126.1,582.5,132.7,574.7,132.7z M639.8,122.6 c-7.7,0-15.5,3.4-18.8,10.8l9.3,3.9c2-3.9,5.7-5.2,9.6-5.2c5.5,0,11,3.3,11.1,9.1v0.7c-1.9-1.1-6-2.7-11-2.7 c-10.1,0-20.3,5.5-20.3,15.9c0,9.5,8.3,15.5,17.5,15.5c7.1,0,11-3.2,13.4-6.9h0.4v5.5h10.2v-27C661.1,129.6,651.8,122.6,639.8,122.6 z M638.4,161.2c-3.4,0-8.3-1.7-8.3-6c0-5.5,6-7.5,11.2-7.5c4.6,0,6.8,1,9.6,2.4C650.2,156.4,644.8,161.2,638.4,161.2z M698.2,124.1 l-12.1,30.6h-0.4l-12.5-30.6h-11.3l18.8,42.8l-10.7,23.8h11l28.9-66.5H698.2z M603.3,169.3h10.5V98.7h-10.5V169.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3477.748,
    y1: 257.9169,
    x2: 3469.6135,
    y2: 262.1159,
    gradientTransform: "matrix(11.64 0 0 22.55 -40357.9961 -5766.8989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006569999,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.9,42.5c-1.6,1.8-2.6,4.4-2.6,8v124.8c0,3.5,0.9,6.2,2.6,7.9l0.4,0.4l69.9-69.9V112l-70-69.9L58.9,42.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114066187297648568330000013761854350104054715_",
    gradientUnits: "userSpaceOnUse",
    x1: 3397.6501,
    y1: 170.9449,
    x2: 3382.7214,
    y2: 170.9449,
    gradientTransform: "matrix(9.145 0 0 7.7 -30880.6133 -1203.4333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000114066187297648568330000013761854350104054715_)"
    },
    d: " M152.5,137l-23.3-23.3V112l23.3-23.3L153,89l27.6,15.7c7.9,4.4,7.9,11.8,0,16.3L153,136.7C153,136.7,152.5,137,152.5,137z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143611271208664423470000003548435651610410172_",
    gradientUnits: "userSpaceOnUse",
    x1: 3549.9998,
    y1: 217.2275,
    x2: 3541.4509,
    y2: 228.3182,
    gradientTransform: "matrix(15.02 0 0 11.5775 -53180.9297 -2389.1506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000143611271208664423470000003548435651610410172_)"
    },
    d: " M153,136.7l-23.8-23.8l-70.3,70.3c2.6,2.8,6.9,3.1,11.7,0.4L153,136.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101073227420953483250000003339918977700364438_",
    gradientUnits: "userSpaceOnUse",
    x1: 3543.4146,
    y1: 207.3988,
    x2: 3547.2319,
    y2: 212.354,
    gradientTransform: "matrix(15.02 0 0 11.5715 -53180.9297 -2398.9072)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000101073227420953483250000003339918977700364438_)"
    },
    d: " M153,89L70.6,42.2c-4.8-2.8-9.2-2.4-11.7,0.4l70.3,70.3L153,89z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M152.5,136.2l-81.9,46.5c-4.6,2.6-8.7,2.4-11.3,0.1l-0.4,0.4l0.4,0.4c2.6,2.4,6.7,2.6,11.3-0.1l82.4-46.8 L152.5,136.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.6,120.2l-28.2,16l0.5,0.5l27.6-15.7c4-2.3,5.9-5.2,5.9-8.1C186.2,115.5,184.2,118.1,180.6,120.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M70.6,43l110,62.5c3.6,2,5.6,4.6,5.9,7.3c0-2.9-1.9-5.9-5.9-8.1l-110-62.5c-7.9-4.5-14.3-0.7-14.3,8.3v0.8 C56.3,42.3,62.7,38.6,70.6,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.3b1480a9411ac6224935417260cb2b52.svg";
export { ForwardRef as ReactComponent };